import React from "react";

const Loading: React.FC = () => {
    return (
        <div className="text-center py-20 text-white">
            <div className="w-12 h-12 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto mb-5"></div>
            <p>Loading result...</p>
        </div>
    );
};

export default Loading;